import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useAdminLanguage } from './AdminI18n';

function BarcodeAdmin() {
  const { t } = useAdminLanguage();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {t('Référence code-barre')}
      </Typography>
      <Paper sx={{ p: 3, mt: 2 }}>
        <Typography variant="body1" color="text.secondary">
          {t('Cette page est en cours de développement.')}
        </Typography>
      </Paper>
    </Box>
  );
}

export default BarcodeAdmin;


